import revisionNumbersList from "./revision-number/total-returns-to-author-before-ae-pcori-assignment";

export default [...revisionNumbersList];